/*  ==========================================================================
		PHP Variables
		========================================================================== */

// If you need to access variables such as template url, or AJAX url within this file you can use the variable php_variables.template_url or php_variables.ajax_url
// which has been passed in via enqueue-scripts.php

/*  ==========================================================================
		Grid variables - needed for gridcarousel__init
		========================================================================== */

// NOTE: If your updating this make sure to also update the SASS Variables in _variables.scss
const gridSizes = {
  sm: "550",
  md: "700",
  lg: "1000",
  xl: "1200",
  ws: "1400",
  xw: "1600",
  xxw: "1800",
  xxxw: "2000"
};

/*  ==========================================================================
      DOM element variables 
      ========================================================================== */

const body = document.querySelector("body");

/*  ==========================================================================
		Device Detection - Check if is mobile or ipad
		========================================================================== */

let isMobile = false; // initiate as false
const isTouchDevice = !!("ontouchstart" in window);

if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) {
  isMobile = true;
}

/*  ==========================================================================
		Returns window size 
		========================================================================== */

// const windowSize = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

const getWindowSize = function (windowSize) {
  windowSize = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  return windowSize;
}; // getWindowSize();

getWindowSize();

/*  ==========================================================================
		GENERAL - add linklines to links
		========================================================================== */

const linksInit = function () {
  const links = document.querySelectorAll("a:not(.noline):not(.line-added)");
  links.forEach(function (el) {
    if (el.closest(".noline")) {
      return;
    }

    const icon = el.querySelector(".fa, .fas, .far, .fal, .fab");

    if (el.querySelector("img") < 1) {
      const linkHTML = "<span class='linkline'>" + el.textContent + "</span>";
      el.innerHTML = linkHTML;
      el.classList.add("line-added");
      if (icon) {
        const iconHTML = icon;
        if (icon.classList.contains("fa--left")) {
          el.querySelector(".linkline").before(icon);
        } else {
          el.querySelector(".linkline").after(icon);
        }
      }
    }
  });
  //return true;
}; // linksInit();
linksInit();

/*  ==========================================================================
    GENERAL - sharinglinks
    ========================================================================== */

const sharingLinksInit = function () {
  const links = document.querySelector(".shareiconslist");

  if (!links) {
    return;
  }

  links.addEventListener("click", function (e) {
    e.preventDefault();
    const clicked = e.target.closest(".sharelink--popup");

    if (!clicked) {
      return;
    }

    const shareURL = clicked.getAttribute("href");
    window.open(shareURL, "share-dialog", "width=550,height=436");
  });
}; // sharingLinksInit();
sharingLinksInit();

/*  ==========================================================================
    GENERAL - accordion
    ========================================================================== */

const accordionQuestions = document.querySelectorAll(".accordion__question");

const accordionInit = function (accordionItems) {
  if (!accordionItems) {
    return;
  }

  accordionItems.forEach(item =>
    item.addEventListener("click", function () {
      item.closest(".accordion__item").classList.toggle("accordion__item--open");
    })
  );
}; // accordionInit();
accordionInit(accordionQuestions);

/*  ==========================================================================
    GENERAL - LazyLoad - Enable Lazy load for images
    ========================================================================== */

// Lazy load images (or everything with .lazy)
const lazyLoadInstance = new LazyLoad();

/*  ==========================================================================
    GENERAL - Initiate plyr (custom video controls)

    This is automatically disabled on builds, to enable uncomment the JS here
    and then go to functions / enqueue-scripts and enqueue-styles to uncomment and enable the css and JS 

    ========================================================================== */

// const plyrsInit = function () {
//   const plyrs = document.querySelectorAll(".mediavideo:not(.mediavideo--autoplay)");

//   if (!plyrs) {
//     return;
//   }

//   plyrs.forEach(function (el) {
//     let plyr = el.querySelector(".mediavideo__video");
//     new Plyr(plyr, {
//       controls: ["play", "progress", "mute", "current-time"],
//       hideControls: true,
//       invertTime: false,
//       tooltips: { controls: false, seek: false }
//     });
//   });
// }; // plyrsInit();

// plyrsInit();

/*  ==========================================================================
  GENERAL - Share Icons
========================================================================== */
const socialLinksInit = function () {
  const socialLinks = document.querySelectorAll(".sociallink");

  if (!socialLinks) {
    return;
  }

  socialLinks.forEach(socialLink =>
    socialLink.addEventListener("click", function (e) {
      e.preventDefault();
      const shareURL = this.getAttribute("href");
      var w = 550;
      var h = 550;
      var left = Number(screen.width / 2 - w / 2);
      var tops = Number(screen.height / 2 - h / 2);
      window.open(
        shareURL,
        "share-dialog",
        "resizable=no, width=" + w + ", height=" + h + ", top=" + tops + ", left=" + left + ""
      );
    })
  );
}; // socialLinksInit();
socialLinksInit();

/*  ==========================================================================
    GENERAL - Fancybox
  ========================================================================== */
const fancyboxInit = function () {
  const fancyboxOptions = {
    Hash: false, // Disabling Hash-based navigation, as it doesn't work on page reload
    Thumbs: false // Disable thumbnails
  };

  Fancybox.bind("[data-fancybox]", fancyboxOptions);
}; // fancyboxInit();

fancyboxInit();

/*  ==========================================================================
    GENERAL - Anchors
    ========================================================================== */

const pagenav = document.querySelectorAll(".pagenav");

const pagenavInit = function (pagenav) {
  if (!pagenav) {
    return;
  }
  const pagenavLinks = document.querySelectorAll(".pagenav__link");
  pagenavLinks.forEach(navLink =>
    navLink.addEventListener("click", function () {
      document.querySelector(this.getAttribute("href")).scrollIntoView({ behavior: "smooth", block: "start" });
    })
  );
}; // pagenavInit();
pagenavInit(pagenav);

/*  ==========================================================================
    GENERAL - Accordion & Media
  ========================================================================== */

const setActiveItem = function (accordionMediaItems, item) {
  accordionMediaItems.forEach(el => {
    el.classList.remove("active");
    el.querySelector(".item__content").style.height = "0px";
  });
  item.classList.add("active");
  let innerHeight = item.querySelector(".item__inner").offsetHeight;
  item.querySelector(".item__content").style.height = innerHeight + "px";
};

const accordionMediaInit = function () {
  const accordionMedia = document.querySelectorAll(".module--accordion-media");

  if (!accordionMedia) {
    return;
  }

  accordionMedia.forEach(module => {
    const accordionMediaItems = module.querySelectorAll(".accordion-media__item");

    if (!accordionMediaItems) {
      return;
    }

    accordionMediaItems.forEach(item => {
      item.addEventListener("click", function () {
        setActiveItem(accordionMediaItems, this);
      });
    });

    // set first item as active on load
    setActiveItem(accordionMediaItems, accordionMediaItems[0]);

    window.addEventListener(
      "resize",
      function (event) {
        setActiveItem(accordionMediaItems, module.querySelector(".accordion-media__item.active"));
      },
      true
    );
  });
};
accordionMediaInit();

/*  ==========================================================================
    AJAX - AJAX load more / paging
    ========================================================================== */

const loadmoreBtn = document.querySelector(".paging__loadmore");
const loadmoreContainer = document.querySelector(".loadmore-container");

const loadmoreLoadPostsMultiplePages = function (pages) {
  if (pages && pages > 1) {
    //Stopping default scroll back to previous position
    history.scrollRestoration = "manual";

    const currentPage = new URL(window.location);

    //Creating an array on page numbers to map it
    var list = [];
    for (var i = 1; i < pages; i++) {
      list.push(i);
    }

    // Initialising the array of posts pages
    var postsHTML = [];

    const button = loadmoreBtn;
    const buttonText = button.textContent; // store current button text
    button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts

    // Array of ajax calls
    var allAJAX = list.map(function (page) {
      const data = {
        action: "loadmore",
        query: php_variables.posts, // that's how we get params from wp_localize_script() function
        page: page
      };
      //Updating the url to mtch the page number
      currentPage.searchParams.set("pagenum", page);
      return $.ajax({
        url: php_variables.ajax_url, // AJAX handler
        data: data,
        type: "POST",
        success: function (data) {
          postsHTML[page] = data;
        }
      });
    });

    // Waiting for all the ajax calls to be finished before proceeding
    Promise.all(allAJAX).then(function () {
      // Update current page variable
      php_variables.current_page = pages;

      button.textContent = buttonText; // set back to previous button text

      // Adding the new tiles to the dom
      list.map(page => {
        if (postsHTML[page]) {
          loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + postsHTML[page];
        }
      });

      // Updating the href for the loadmore button
      const nextPage = new URL(window.location);
      nextPage.searchParams.set("pagenum", parseInt(pages) + 1);
      button.href = nextPage;

      // if last page, remove the button..
      if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
        button.style.display = "none";
      }

      // Re-init lazy load
      lazyLoadInstance.update(); // reinit lazy load after clones
      // Re-init effects
      const effects = document.querySelectorAll(".effect");
      effectsInit(effects);

      // Scrolling the page to the last known position
      if (localStorage.getItem("scrollPosition")) {
        window.scroll({
          top: parseInt(localStorage.getItem("scrollPosition"), 10),
          behavior: "instant"
        });
      }
    });
  }
};

const loadmoreLoadPosts = function (e) {
  e.preventDefault(); // Preventing the a tag from redirecting to the page

  const button = this;
  const data = {
    action: "loadmore",
    query: php_variables.posts, // that's how we get params from wp_localize_script() function
    page: php_variables.current_page
  };
  let buttonText; // create variable to store button text

  // This AJAX triggers a PHP hook within functions-ajax.php called ajax_loadmore_handler
  $.ajax({
    url: php_variables.ajax_url, // AJAX handler
    data: data,
    type: "POST",
    beforeSend: function (xhr) {
      buttonText = button.textContent; // store current button text
      button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts
    },
    success: function (data) {
      if (data) {
        button.textContent = buttonText; // set back to previous button text
        loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + data; // insert new posts to the loadmore-container, this should be the row that includes the posts

        php_variables.current_page++;

        // Only push state to set the last page number or if there is more pages to load
        const currentPage = new URL(window.location);

        if (parseInt(php_variables.current_page) <= parseInt(php_variables.max_page)) {
          currentPage.searchParams.set("pagenum", php_variables.current_page);
          history.pushState({}, "", currentPage);
        }

        //Updating the loadmore link
        const nextPage = new URL(window.location);
        nextPage.searchParams.set("pagenum", parseInt(php_variables.current_page) + 1);

        button.href = nextPage;

        // if last page, remove the button..
        if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
          button.style.display = "none";
        }
        // Re-init links to make sure linklines on newly loaded content still work
        linksInit();
        // Re-init lazy load
        lazyLoadInstance.update(); // reinit lazy load after clones
        // Re-init effects
        const effects = document.querySelectorAll(".effect");
        effectsInit(effects);
      } else {
        button.style.display = "none"; // if no data, remove the button as well
      }
    }
  });
}; // loadmoreLoadPosts();

const loadmoreInit = function () {
  if (!loadmoreBtn) {
    return;
  }
  /** When adding fitering you will need to move this part into the filtering call */
  // Checking if the page paramenter is set
  const currentPage = new URL(window.location);
  let currentPageNum = currentPage.searchParams.get("pagenum");

  //If there is more than one page to load
  if (currentPageNum && currentPageNum > 1) {
    currentPageNum = currentPageNum > php_variables.max_page ? php_variables.max_page : currentPageNum;
    loadmoreLoadPostsMultiplePages(currentPageNum);
  }
  /** -end- */

  // Saving the scroll position before unload
  window.addEventListener("unload", function (e) {
    var scrollPosition = window.pageYOffset;
    localStorage.setItem("scrollPosition", scrollPosition);
  });

  loadmoreBtn.addEventListener("click", loadmoreLoadPosts);
}; // loadmoreInit();

loadmoreInit();

/*  ==========================================================================
    Scroll effects
    ========================================================================== */

const effects = document.querySelectorAll(".effect");

const effectsInit = function (effects) {
  if (!effects) {
    return;
  }

  effects.forEach(function (val) {
    const waypoints = new Waypoint({
      element: val,
      handler: function (direction) {
        if (direction === "down") {
          val.classList.add("effect--ready");
        } else {
          val.classList.remove("effect--ready");
        }
      },
      offset: "90%"
    });
  });
}; // effectsInit();
effectsInit(effects);

/*  ==========================================================================
    Info point rellax
    ========================================================================== */
const infoPoints = document.querySelectorAll(".pageheader__info__points");

const infoPointsInit = function (infoPoints) {
  if (!infoPoints || infoPoints.length === 0) {
    return;
  }

  let rellax = new Rellax(".rellax", {});
}; // infoPointsInit();

infoPointsInit(infoPoints);

/*  ==========================================================================
    Scroll effects
    ========================================================================== */
const infoPoint = document.querySelectorAll(".info__point");

const infoPointInit = function (infoPoint) {
  if (!infoPoint) {
    return;
  }
  infoPoint.forEach(function (val) {
    window.setTimeout(function () {
      val.classList.add("info__point--ready");
    }, 200);
  });
}; // infoPointInit();

if (getWindowSize > gridSizes.lg) {
  infoPointInit(infoPoint);
}

window.addEventListener(
  "resize",
  function () {
    if (getWindowSize > gridSizes.lg) {
      infoPointInit(infoPoint);
    }
  },
  true
);

/*  ==========================================================================
  Rotating Statistic animation
    ========================================================================== */

const circularAnimationContainer = document.querySelectorAll(".circular__animation__image");

const statisticCircularAnimationInit = function () {
  if (!circularAnimationContainer || circularAnimationContainer.length === 0) {
    return;
  }
  const circularAnimation = document.querySelectorAll(".circular__animation");
  circularAnimation.forEach(animation => {
    const imageCircle = [...animation.querySelectorAll(".circular__animation__image")];

    const rotateDeg = 360 / imageCircle.length;

    imageCircle.forEach((wrp, idx) => {
      wrp.style.transform = `translate(0%, 0%) rotate(${rotateDeg * idx}deg)`;
      wrp.querySelector(".image__container").style.transform = `translate(0%, 0%) rotate(-${rotateDeg * idx}deg)`;
    });
  });
}; // statisticCircularAnimationInit();

statisticCircularAnimationInit();

/*  ==========================================================================
    Statistics - scroll effect
    ========================================================================== */
const statisticCircleProgress = document.querySelectorAll(".statistic__circle");

const statisticCircleInit = function () {
  if (!statisticCircleProgress || statisticCircleProgress.length === 0) {
    return;
  }

  statisticCircleProgress.forEach(statisticCircle => {
    const waypoints = new Waypoint({
      element: statisticCircle,
      handler: function (direction) {
        if (direction === "down") {
          var empty_fill = getComputedStyle(statisticCircle.querySelector(".statistic__circle__emptyfill"));
          empty_fill = empty_fill.backgroundColor;

          var fill = getComputedStyle(statisticCircle.querySelector(".statistic__circle__fill"));
          fill = fill.backgroundColor;

          var start_angle = -(3.141592653589793238 / 2); // (Math.PI / 2) - changed to number as Math.PI was throwing babel error
          $(".statistic__circle").circleProgress({
            size: 500,
            thickness: 10,
            startAngle: start_angle,
            emptyFill: empty_fill,
            fill: {
              color: fill
            }
          });
        }
      },
      offset: "90%"
    });
  });
};
statisticCircleInit();

/*  ==========================================================================
			Grid Carousel (Currently used on Featured Posts & Featured People)
			========================================================================== */

const gridCarousels = document.querySelectorAll(".row--carousel .owl-carousel");

const gridCarouselInit = function (gridCarousels) {
  if (gridCarousels.length <= 0) {
    return;
  }

  gridCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".col");
    if (!slides) {
      return;
    }

    const responsiveArray = carouselResponsiveArray(elem);

    // Optional data attribute settings
    const autoplay = elem.dataset.autoplay ? elem.dataset.autoplay : false;
    const autoplayTimeout = elem.dataset.autoplayTimeout ? elem.dataset.autoplayTimeout : 5000;
    const loop = elem.dataset.loop ? elem.dataset.loop : false;
    const nav = elem.dataset.nav ? elem.dataset.nav : false;
    const dots = elem.dataset.dots ? elem.dataset.dots : false;
    // Default for autoheight is "true", so to turn off you need to set the data-attribute to "disable"
    const autoHeight = elem.dataset.autoHeight && elem.dataset.autoHeight === "disable" ? false : true;

    $(elem).owlCarousel({
      autoplay: autoplay,
      autoplayTimeout: autoplayTimeout,
      loop: loop,
      nav: nav,
      dots: dots,
      items: 0,
      navText: ["<i class='far fa-arrow-left'></i>", "<i class='far fa-arrow-right'></i>"],
      responsive: responsiveArray,
      startPosition: slides.length,
      autoHeight: autoHeight,
      onInitialized: function () {
        lazyLoadInstance.update();
        Waypoint.refreshAll();
      }
    });

    $(elem).on("resized.owl.carousel", function (event) {
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });
  });
}; // gridCarouselInit();
gridCarouselInit(gridCarousels);

/*  ==========================================================================
    Grid Carousel - Create responsive array 
    ========================================================================== */

function carouselResponsiveArray(elem) {
  let responsiveArray = {};
  const slides = elem.querySelectorAll(".col");
  const classes = slides[0].classList;

  classes.forEach((cl, index) => {
    if (cl.indexOf("col-") !== -1) {
      let className = cl;
      let classWidth = 0;
      let numItems = 4;
      className = cl.replace("col-", "");
      // get min width from col class
      const classGridsize = className.split("-")[0];
      // check this is a string not a number, this will remove up cols that dont have a grid size e.g. col-1-2
      if (isNaN(classGridsize)) {
        className = className.replace(classGridsize + "-", "");
        classWidth = gridSizes[classGridsize];
      } else {
        classWidth = 0;
      }
      // split rest of class into sections (this should now be something like '1-4')
      const otherClassParts = className.split("-");
      // divide second number (e.g 4) by first number (e.g 1) to get number of items
      if (otherClassParts[1]) {
        numItems = otherClassParts[1] / otherClassParts[0];
      } else {
        numItems = 1; // if there isn't a second number it must be a single grid
      }
      responsiveArray[classWidth] = {
        items: numItems
      };
    }
  });

  return responsiveArray;
} // carouselResponsiveArray();

/*  ==========================================================================
    Marquee - Infinite Scroll
    ========================================================================== */

var default_animation_speed = 1.5;

var el_class = "marquee";
var inner_class = "marquee__wrap";

$("." + el_class).each(function () {
  marquee__init($(this));
});

$(window).resize(function () {
  $("." + el_class).each(function () {
    marquee__resize($(this));
  });
});

function marquee__init($el) {
  // Setup two scroll wraps (duplicate the HTML)
  $el.wrapInner("<div class='" + inner_class + "'></div>");
  $el
    .find("." + inner_class)
    .clone()
    .appendTo($el);
  $el
    .find("." + inner_class + ":first-child()")
    .clone()
    .appendTo($el);
  $el
    .find("." + inner_class + ":first-child()")
    .clone()
    .appendTo($el);
  $el
    .find("." + inner_class + ":first-child()")
    .clone()
    .appendTo($el);

  lazyLoadInstance.update(); // reinit lazy load after clones

  // Setup animation times
  marquee__resize($el);

  // Once everything is set up, add "loaded" class
  $el.addClass(el_class + "--loaded");
}

function marquee__resize($el) {
  // Check if element has custom speed or default
  var animation_speed = default_animation_speed;
  if ($el.data("speed")) {
    animation_speed = $el.data("speed");
  } else {
    animation_speed = default_animation_speed;
  }

  // Set animation time
  var linelength = $("." + inner_class, $el).width();
  var distance = linelength;

  var speed = animation_speed * 0.01;
  var duration = distance / speed;
  var delay = 0 - duration / 3;

  $el.find("." + inner_class).css("animation-duration", duration + "ms");
  $el.find("." + inner_class + ":first-child()").css("animation-delay", delay + "ms");
  $el.find("." + inner_class + ":nth-child(2)").css("animation-delay", delay * 2 + "ms");
  $el.find("." + inner_class + ":nth-child(3)").css("animation-delay", delay * 3 + "ms");
  $el.find("." + inner_class + ":nth-child(4)").css("animation-delay", delay * 4 + "ms");
  $el.find("." + inner_class + ":nth-child(5)").css("animation-delay", delay * 5 + "ms");
}

/*  ==========================================================================
	NAVIGATION - mobnav
	========================================================================== */

const mobnav = document.querySelector(".mobnav");
const siteHeaderBd = document.querySelector(".siteheader__bd");
const mobnavToggle = document.querySelector(".mobnav-toggle");
const mobnavOpenclass = "mobnavopen";

const mobnavSetHeight = function () {
  const mobnavHeight = window.innerHeight - siteHeaderBd.getBoundingClientRect().height;
  mobnav.style.height = `${mobnavHeight}px`;
}; // mobnavSetHeight()

const mobnavInit = function () {
  // Open mobnav on click the toggle
  mobnavToggle.addEventListener("click", function (e) {
    e.preventDefault();

    let mobnavHeight = 0;
    if (!body.classList.contains(mobnavOpenclass)) {
      // IT'S NOT OPEN...
      mobnavSetHeight();
      body.classList.add(mobnavOpenclass);
    } else {
      // IT'S OPEN...
      mobnav.style.height = 0;
      body.classList.remove(mobnavOpenclass);
    }
  });
}; // mobnavInit()
mobnavInit();

// On resize check mobnav height is still right
const mobnavResize = function () {
  let mobnavHeight = 0;
  if (body.classList.contains(mobnavOpenclass)) {
    mobnavSetHeight();
  }
}; // mobnavResize()

window.addEventListener(
  "resize",
  function (event) {
    mobnavResize();
  },
  true
);

/*  ==========================================================================
      NAVIGATION - mobnav dropdowns
      ========================================================================== */

const mobnavLinks = document.querySelectorAll(".mobnav .sitenav__item--hasdropdown .sitenav__item__dropdownarrow");

const mobnavlinksInit = function () {
  if (!mobnavLinks) {
    return;
  }

  mobnavLinks.forEach(function (mobnavLink) {
    mobnavLink.addEventListener("click", function (e) {
      e.preventDefault();
      const mobnavTargetSection = e.target.closest(".sitenav__item");
      mobnavTargetSection.classList.toggle("sitenav__item--open");
      var panel = this.parentElement.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  });
}; // mobnavlinksInit();
mobnavlinksInit();

/*  ==========================================================================
			NAVIGATION - sitenav dropdowns
			========================================================================== */

const sitenav = document.querySelector(".siteheader");
const sitenavitems = sitenav.querySelectorAll("li[data-dropdownsection]");
const sitenavdropdown = document.querySelector(".sitenav__dropdown");

const overclass = "sitenav__item--over";
const navopenbodyclass = "sitenavopen";
const activesectionclass = "dropdownsection--active";

var navopen = false;
var currentli = false;
var dropdownclosetimer = false;

// Check if isMobile, and only init if desktop or Ipad
if (!isMobile) {
  sitenav__init();
}

function sitenav__init() {
  // Check if is touchscreen and setup dropdown to show on tap as well as hover
  if (isTouchDevice) {
    // IF TOUCHSCREEN (e.g. Ipad users)...
    // Setup dropdown to show on tap
    sitenavitems.forEach(function (sitenavitem) {
      sitenavitem.addEventListener("click", function (e) {
        e.preventDefault();
        if (!this.classList.contains(overclass)) {
          navopen = false;
          sitenavitem__over(sitenavitem);
        } else {
          sitenav__out();
        }
      });
    });
  } else {
    // IF DESKTOP...
    sitenavitems.forEach(function (sitenavitem) {
      sitenavitem.addEventListener("mouseover", e => {
        sitenavitem__over(sitenavitem);
      });
      sitenavitem.addEventListener("mouseout", e => {
        sitenav__out();
      });
    });
    sitenavdropdown.addEventListener("mouseover", e => {
      dropdownsection__over();
    });
    sitenavdropdown.addEventListener("mouseout", e => {
      sitenav__out();
    });
  }
} // sitenav__init()

function sitenavitem__over(sitenavitem) {
  // On hover of sitenav item
  dropdownsection__open(sitenavitem);
} // sitenavitem__over()

function dropdownsection__open(target_li) {
  var target_section = sitenavdropdown.querySelector(".dropdownsection--" + target_li.dataset.dropdownsection);
  var dropdown_height = target_section.offsetHeight;

  // Make dropdown show and set classes to say it's open
  sitenavdropdown.style.height = dropdown_height + "px";
  navopen = true;
  if (dropdownclosetimer) {
    // Clear timeout to stop dropdown closing
    window.clearTimeout(dropdownclosetimer);
  }
  // Remove over class from any old clicks
  if (document.querySelector("." + overclass)) {
    document.querySelector("." + overclass).classList.remove(overclass);
  }
  // add over class to current li
  target_li.classList.add(overclass);
  document.querySelector("body").classList.add(navopenbodyclass);
  if (document.querySelector("." + activesectionclass)) {
    document.querySelector("." + activesectionclass).classList.remove(activesectionclass);
  }
  target_section.classList.add(activesectionclass);
} //dropdownsection__open();

function dropdownsection__over() {
  // On hover of dropdownsection, keep the dropdown open
  navopen = true;
  if (dropdownclosetimer) {
    // Clear timeout to close the dropdown
    window.clearTimeout(dropdownclosetimer);
  }
  document.querySelector("body").classList.add(navopenbodyclass);
} // sitenavitem__over()

function sitenav__out() {
  // On leave sitenav hover
  navopen = false;
  // Start timeout to close sitenav dropdown
  dropdownclosetimer = window.setTimeout(sitenav__close, 250);
} // sitenavitem__over()

function sitenav__close() {
  // when time out ends and nav open is still false, close the sitenav
  if (!navopen) {
    // Set height to 0 and remove classes
    if (document.querySelector("." + activesectionclass)) {
      document.querySelector("." + activesectionclass).classList.remove(activesectionclass);
    }
    document.querySelector("body").classList.remove(navopenbodyclass);
    if (document.querySelector("." + overclass)) {
      document.querySelector("." + overclass).classList.remove(overclass);
    }
    sitenavdropdown.style.height = 0;
  }
} // sitenav__close

/*  ==========================================================================
    GENERAL - Navigation Hover
    ========================================================================== */

const navigationHover = function () {
  const sitenavLinks = document.querySelectorAll(".sitenav__item:not(.sitenav__item--btn)");

  if (!sitenavLinks) {
    return;
  }

  sitenavLinks.forEach(function (sitenavLink) {
    sitenavLink.addEventListener("mouseover", () => {
      var elements = [...document.querySelectorAll(".sitenav__item:not(.sitenav__item--btn)")];

      var otherElements = elements.filter(function (element) {
        return element !== sitenavLink;
      });

      otherElements.forEach(element => {
        element.classList.add("o-50");
      });
    });

    sitenavLink.addEventListener("mouseout", () => {
      sitenavLinks.forEach(element => {
        element.classList.remove("o-50");
      });
    });
  });
}; // navigationHover();

if (!isMobile && screen.width > gridSizes.lg) {
  navigationHover();
}
